import React from 'react';

interface DropdownHeaderProps {
  noteText?: React.ReactNode;
  allowMultiple?: boolean;
}

const DropdownHeader: React.FC<DropdownHeaderProps> = ({
  noteText,
  allowMultiple = false,
}) => {
  if (!allowMultiple && !noteText) return null;

  return (
    <div className="self-stretch p-4 bg-neutral-050 inline-flex flex-col justify-start items-start gap-2">
      <div className="self-stretch justify-start text-primary text-xs font-normal font-['Inter'] leading-4 line-clamp-2">
        {noteText || (
          <>
            <span className="font-semibold">Note:</span> To ensure feature
            performance, a{' '}
            <span className="font-semibold">maximum of 10 code sets</span> can
            be selected.
          </>
        )}
      </div>
    </div>
  );
};

export default DropdownHeader;
